import { SolidExclamationCircleIcon } from '@tempmee/react-icons';
import { Row, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';

export const GeneralErrorMessage = () => (
  <Row gap={2} align="center" width="800px">
    <SolidExclamationCircleIcon color={colors.error[500]} />
    <Typography as="span" color={colors.error[500]}>
      Oops! It looks like a few required fields were left empty.
    </Typography>
  </Row>
);
